<template>
	<div>
		<DialogHeader
			closable
			@cancel="$emit('close')"
			class="py-4"
			:title="$t('common.guest_banner.title')"
		/>
		<DialogBody>
			<p>
				{{ $t('common.guest_banner.description') }}
			</p>
		</DialogBody>
		<DialogActions
			:vertical-actions="isXS"
			:accept-action="login"
			:cancel-action="close"
			@accept="goToLogin"
			@cancel="continueExploring"
		/>
	</div>
</template>

<script setup lang="ts">
	import { useRoute } from 'vue-router'
	import { AuthNavigation } from '~/services/navigation/authNavigation'
	import { useAuthStore } from '~/store/auth'

	const route = useRoute()
	const routeStore = useAuthStore()
	const { t } = useI18n()
	interface Props {
		isXS: boolean
		routeToGoAfterLogin?: string
	}
	const props = defineProps<Props>()
	const emit = defineEmits(['close'])

	const login = { text: t('common.guest_banner.button.auth') }
	const close = { text: t('common.guest_banner.button.continue') }

	const continueExploring = () => {
		emit('close')
	}

	const goToLogin = () => {
		emit('close')
		let redirectionRoute = props.routeToGoAfterLogin
		if (!redirectionRoute) redirectionRoute = route.fullPath ?? route.path
		routeStore.setPreviousRoute(redirectionRoute)
		AuthNavigation.toLogin()
	}
</script>
